import React from 'react';
import BoxShadow from "./pages/tool-boxShadow";

function App() {
  return (
    <>
      <BoxShadow />
    </>
  );
}

export default App;
